import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../../index.css";

class NonAuthLayout extends Component {
  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentDidUpdate(previousProps) {
    if (previousProps.location.pathname !== this.props.location.pathname) {
      this.updateDocumentTitle();
    }
  }

  getPageTitle = (pathname) => {
    const titles = {
      "/login/organization": "Organization Login",
      "/login": "Recruiter Login",
      "/register/organization": "Organization Registration",
      "/register": "Recruiter Registration",
      "/forgot-password/organization": "Organization Forgot Password",
      "/forgot-password": "Recruiter Forgot Password",
      "/setpassword": "Set Password",
      "/resetpassword": "Reset Password",
      "/terms-conditions": "Terms and Conditions",
      "/contactus": "Contact Us",
    };

    return titles[pathname] || "HireNeuron";
  };

  updateDocumentTitle = () => {
    const pageTitle = this.getPageTitle(this.props.location.pathname);
    document.title =
      pageTitle === "HireNeuron" ? "HireNeuron" : `${pageTitle} | HireNeuron`;
  };

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object.isRequired,
};

export default withRouter(NonAuthLayout);
